module.exports = __webpack_public_path__ + "img/vote_bronze.07ca1363.png";